import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DiffOutlinedSvg from "@ant-design/icons-svg/es/asn/DiffOutlined";
import AntdIcon from "../components/AntdIcon";
var DiffOutlined = function DiffOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DiffOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DiffOutlined.displayName = 'DiffOutlined';
}
export default /*#__PURE__*/React.forwardRef(DiffOutlined);